import { render, staticRenderFns } from "./index_zhz.vue?vue&type=template&id=4ca4dd0e&scoped=true&"
import script from "./index_zhz.vue?vue&type=script&lang=js&"
export * from "./index_zhz.vue?vue&type=script&lang=js&"
import style0 from "./index_zhz.vue?vue&type=style&index=0&id=4ca4dd0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca4dd0e",
  null
  
)

export default component.exports